// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"bd1442c6b6513e32","395":"f27f04f0563d1314"}[chunkId] + ".css";
};